import * as React from 'react';
import { Form } from 'semantic-ui-react';

import Panel from 'src/modulos/Matriculas/IngresoNuevaMatricula/componentes/Panel';

import { mapStringToOptions } from 'src/modulos/Matriculas/IngresoNuevaMatricula/utils/mapStringToOptions';

import CorreosElectronicos, {
    Datos as CorreosElectronicosDatos,
    inicial as correosElectronicosInicial,
} from '../../componentes/CorreosElectronicos';
import Direcciones, {
    Datos as DireccionesDatos,
    inicial as direccionesInicial,
} from '../../componentes/Direcciones';
import Personales, {
    Datos as PersonalesDatos,
    inicial as personalesInicial,
} from '../../componentes/Personales';
import Telefonos, {
    Datos as TelefonosDatos,
    inicial as telefonosInicial,
} from '../../componentes/Telefonos';
import SeleccionableOtro, {
    Datos as SeleccionableOtroDatos,
    inicial as seleccionableOtrosInicial,
} from '../SeleccionableOtro';

import colores from '../../colores';

export interface Datos {
    personales: PersonalesDatos;
    telefonos: TelefonosDatos;
    correos: CorreosElectronicosDatos;
    facebook: string;

    direcciones: DireccionesDatos;

    ocupacion: SeleccionableOtroDatos;
}

export const inicial: Datos = {
    personales: { ...personalesInicial },
    telefonos: { ...telefonosInicial },
    correos: { ...correosElectronicosInicial },
    facebook: '',

    direcciones: { ...direccionesInicial },

    ocupacion: { ...seleccionableOtrosInicial },
};

const ocupaciones = ['Estudiante', 'Trabajador', 'Otro'];

interface Props {
    mostrar: boolean;
    titulo: string;
    persona: Datos;
    componenteInicial?: React.ReactNode;
    onChange(persona: Datos): void;
}

class PanelPersona extends React.PureComponent<Props> {
    private readonly ocupacionOptions = mapStringToOptions(ocupaciones);

    public render() {
        const { mostrar, titulo, persona, componenteInicial, onChange, children } = this.props;

        return (
            <Panel titulo={titulo} oculto={!mostrar} color={colores.panel}>
                {componenteInicial}

                <Personales
                    requeridos={mostrar}
                    personales={persona.personales}
                    onChange={this.manejarCambioPersonales}
                />

                <Telefonos
                    requeridos={mostrar}
                    telefonos={persona.telefonos}
                    onChange={this.manejarCambioTelefonos}
                />

                <CorreosElectronicos
                    requeridos={mostrar}
                    correos={persona.correos}
                    onChange={this.manejarCambioCorreosElectronicos}
                />

                <Form.Input
                    label='Facebook'
                    width='6'
                    type='url'
                    placeholder='https://www.facebook.com/preuniversitario.alameda.5'
                    value={persona.facebook}
                    onChange={(_e, { value }) => {
                        onChange({
                            ...persona,
                            facebook: value,
                        });
                    }}
                />

                <Direcciones
                    requeridos={mostrar}
                    direcciones={persona.direcciones}
                    onChange={this.manejarCambioDirecciones}
                />

                <br />

                <SeleccionableOtro
                    select={{
                        etiqueta: 'Ocupación',
                        opciones: this.ocupacionOptions,
                        requerido: mostrar,
                    }}
                    input={{
                        etiqueta: 'Especifique',
                        mostrar: () =>
                            mostrar &&
                            persona.ocupacion.id !== 'Estudiante' &&
                            persona.ocupacion.id !== '',
                    }}
                    valor={persona.ocupacion}
                    onChange={valor => {
                        onChange({
                            ...persona,
                            ocupacion: { ...valor },
                        });
                    }}
                />

                {children}
            </Panel>
        );
    }

    private readonly manejarCambioPersonales = (personales: Datos['personales']) => {
        this.props.onChange({
            ...this.props.persona,
            personales,
        });
    };

    private readonly manejarCambioTelefonos = (telefonos: Datos['telefonos']) => {
        this.props.onChange({
            ...this.props.persona,
            telefonos,
        });
    };

    private readonly manejarCambioCorreosElectronicos = (correos: Datos['correos']) => {
        this.props.onChange({
            ...this.props.persona,
            correos,
        });
    };

    private readonly manejarCambioDirecciones = (direcciones: Datos['direcciones']) => {
        this.props.onChange({
            ...this.props.persona,
            direcciones,
        });
    };
}

export default PanelPersona;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/PanelPersona/index.tsx